import ACFBlock from "../../assets/js/blocks-settings/blocks";

/**
 * Custom promoBlockView Block, describe your block here.
 */
class promoBlockView {
	/**
	 * Constructor method
	 * 
	 * @param {HTMLElement} block 
	 */
	constructor(block) {
		// This Js file only runs in the frontend view.
	}

	/**
	 * The name of your block, don't modify this static method!!
	 * 
	 * @return {string}
	 */
	static getName() {
		return "promo_block";
	}

	// Your methods
}

new ACFBlock(promoBlockView);
    